module.exports = __webpack_public_path__ + "img/logo-visit-ouest.b82ac0e3.svg";